import React, { useState, useEffect } from 'react';
import {
  Document, Page, View, Text, StyleSheet, PDFDownloadLink, Image
} from '@react-pdf/renderer';
import logoUrl from '../assets/logo.png';

const BK = '#000000';
const GRAY = '#555555';
const BORDER = '#000000';
const BOX_BG = '#ffffff';

const s = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 24,
    paddingBottom: 22,
    fontFamily: 'Helvetica',
    fontSize: 9,
    color: BK,
    backgroundColor: '#ffffff',
  },

  /* ── CABEÇALHO ── */
  headerBlock: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  headerLogoGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    width: 140,           /* largura fixa = mesmo valor do spacer → título fica no centro exato */
  },
  headerLogo: {
    width: 36,
    height: 36,
    objectFit: 'contain',
  },
  headerBrandName: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 7,
  },
  headerTitleWrap: {
    flex: 1,
    alignItems: 'center',
  },
  headerTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 15,
    textAlign: 'center',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  headerLine: {
    width: '100%',
    height: 1,
    backgroundColor: BK,
    marginTop: 5,
  },

  /* ── MUNICÍPIO ── */
  municipioWrapper: {
    alignItems: 'center',
    marginTop: 4,
    marginBottom: 14,
  },
  municipioLabel: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8,
    marginBottom: 2,
    letterSpacing: 0.8,
  },
  municipioBox: {
    borderWidth: 1,
    borderColor: BORDER,
    backgroundColor: BOX_BG,
    width: '55%',
    minHeight: 18,
    paddingHorizontal: 6,
    paddingVertical: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  municipioValue: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },

  /* ── SEÇÃO ── */
  sectionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 14,
    marginBottom: 6,
  },
  sectionDash: {
    flex: 1,
    height: 0.75,
    backgroundColor: BK,
  },
  sectionLabel: {
    fontFamily: 'Helvetica-BoldOblique',
    fontSize: 9,
    textDecoration: 'underline',
    marginRight: 5,
  },

  /* ── LINHAS ── */
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 13,
  },
  rowWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 13,
  },

  /* ── LABEL acima do campo ── */
  fieldGroup: {
    marginBottom: 11,
  },
  fieldLabel: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 7.5,
    color: '#444',
    marginBottom: 3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  fieldRow: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 11,
  },
  radioOptions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 3,
    gap: 5,
  },

  /* ── LABEL (legado) ── */
  lbl: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 9,
    marginRight: 4,
    flexShrink: 0,
  },
  lblSm: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8.5,
    marginRight: 4,
    flexShrink: 0,
  },

  /* ── BOX ── */
  box: {
    borderWidth: 1,
    borderColor: BORDER,
    backgroundColor: BOX_BG,
    paddingHorizontal: 5,
    paddingVertical: 4,
    minHeight: 23,
    justifyContent: 'center',
  },
  boxText: {
    fontSize: 9,
    color: '#111',
  },

  /* ── RADIO ── */
  optRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  radioItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 6,
    marginBottom: 1,
  },
  radioOuter: {
    width: 8,
    height: 8,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: BK,
    marginRight: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioOuterFilled: { backgroundColor: BK },
  radioInner: {
    width: 3.5,
    height: 3.5,
    borderRadius: 2,
    backgroundColor: '#fff',
  },
  radioLbl: { fontSize: 8 },

  /* ── CHIPS ── */
  chipRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  chip: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: BK,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 3,
  },
  chipSel: { backgroundColor: BK },
  chipTxt: { fontSize: 6.5, color: BK },
  chipTxtSel: { color: '#fff' },

  /* ── DATA ── */
  dateBox: {
    borderWidth: 1,
    borderColor: BORDER,
    paddingHorizontal: 3,
    paddingVertical: 2,
    minHeight: 17,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateSep: { fontSize: 8.5, marginHorizontal: 2 },

  /* ── FOTOS ── */
  fotosPage: {
    paddingHorizontal: 30,
    paddingVertical: 24,
    fontFamily: 'Helvetica',
    fontSize: 8,
    backgroundColor: '#ffffff',
  },
  fotosGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  fotoCaption: {
    fontSize: 7,
    color: GRAY,
    marginTop: 3,
    textAlign: 'center',
  },
});

/* ── PRIMITIVOS ── */

/* Campo com label acima */
const Field = ({ label, value, style, numeric }) => (
  <View style={[s.fieldGroup, style]}>
    <Text style={s.fieldLabel}>{label}</Text>
    <Box value={value} numeric={numeric} />
  </View>
);

/* Campo de rádio com label acima */
const RadioField = ({ label, options, value, style }) => (
  <View style={[s.fieldGroup, style]}>
    <Text style={s.fieldLabel}>{label}</Text>
    <View style={s.radioOptions}>
      {options.map(opt => (
        <Radio key={opt.v} label={opt.l} checked={value === opt.v} />
      ))}
    </View>
  </View>
);

const Radio = ({ label, checked }) => (
  <View style={s.radioItem}>
    <View style={[s.radioOuter, checked && s.radioOuterFilled]}>
      {checked && <View style={s.radioInner} />}
    </View>
    <Text style={s.radioLbl}>{label}</Text>
  </View>
);

const Chip = ({ value, selected }) => (
  <View style={[s.chip, selected && s.chipSel]}>
    <Text style={[s.chipTxt, selected && s.chipTxtSel]}>{String(value)}</Text>
  </View>
);

const Section = ({ title }) => (
  <View style={s.sectionRow}>
    <Text style={s.sectionLabel}>{title}</Text>
    <View style={s.sectionDash} />
  </View>
);

const Box = ({ value, style, numeric }) => {
  const empty = !value || String(value).trim() === '';
  return (
    <View style={[s.box, style]}>
      {empty
        ? <Text style={[s.boxText, { fontFamily: 'Helvetica-Oblique', color: '#aaa', fontSize: 8 }]}>
            {numeric ? '0' : 'não informado'}
          </Text>
        : <Text style={s.boxText}>{value}</Text>
      }
    </View>
  );
};

/* ── DOCUMENTO ── */
export const FormularioCampoPDFDocument = ({
  data, agenteNome, municipioNome,
  fotosUrls = [], fotoDenunciaUrl = null,
  denunciaData = null, feedbackAgente = '', fichaFotosUrls = [],
}) => {
  const actList = (data.tipo_atividade || []).map(a => String(a).toLowerCase());
  const isPesquisa   = actList.includes('pesquisa');
  const isBorrifacao = actList.includes('borrifacao') || actList.includes('borrifação');
  const isPit        = actList.includes('atendimentopit');

  const dateObj = data.data_atividade ? new Date(data.data_atividade) : null;
  const day   = dateObj ? String(dateObj.getUTCDate()).padStart(2, '0')  : '';
  const month = dateObj ? String(dateObj.getUTCMonth() + 1).padStart(2, '0') : '';
  const year  = dateObj ? String(dateObj.getUTCFullYear()) : '';

  const pendPesq = data.pendencia_pesquisa  || 'semPendencias';
  const pendBorr = data.pendencia_borrifacao || 'semPendencias';

  const situacao = data.situacao_imovel || '';
  const paredeMap = {
    alvenaria_reboco: 'Alvenaria com reboco', 'alvenaria c/ reboco': 'Alvenaria com reboco',
    alvenaria_sem_reboco: 'Alvenaria sem reboco', 'alvenaria s/ reboco': 'Alvenaria sem reboco',
    barro_reboco: 'Barro com reboco', 'barro c/ reboco': 'Barro com reboco',
    barro_sem_reboco: 'Barro sem reboco', 'barro s/ reboco': 'Barro sem reboco',
    madeira: 'Madeira', taipa: 'Taipa', palha: 'Palha', outros: 'Outros',
  };
  const paredeNorm = paredeMap[data.tipo_parede] || data.tipo_parede || '';
  const tetoMap = { telha: 'Telha', palha: 'Palha', madeira: 'Madeira', metalico: 'Metálico', outros: 'Outros' };
  const tetoNorm = tetoMap[data.tipo_teto] || data.tipo_teto || '';
  const melhoria = data.melhoria_habitacional;

  const barbIntra = Number(data.barbeiros_intradomicilio) || 0;
  const barbPeri  = Number(data.barbeiros_peridomicilio)  || 0;
  const captIntra = barbIntra > 0 ? 'Triatomíneo' : 'Nenhum';
  const captPeri  = barbPeri  > 0 ? 'Triatomíneo' : 'Nenhum';
  const vestIntra = String(data.vestigios_intradomicilio || 'Nenhum');
  const vestPeri  = String(data.vestigios_peridomicilio  || 'Nenhum');

  const numAnexo  = Number(data.numero_anexo)  || 0;
  const numCargas = Number(data.numero_cargas) || 0;

  const validFotos = (fotosUrls || []).filter(u => u && typeof u === 'string' && u.length > 10);
  const validFicha = (fichaFotosUrls || []).filter(u => u && typeof u === 'string' && u.length > 10);
  const temPag2 = validFotos.length > 0 || !!fotoDenunciaUrl || !!denunciaData || validFicha.length > 0;

  const enderecoFormatado = `${data.endereco || ''}${data.numero ? ', ' + data.numero : ''}`;

  return (
    <Document>
      <Page size="A4" style={s.page}>

        {/* ── CABEÇALHO COMPACTO ── */}
        <View style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 10,
          paddingBottom: 7,
          borderBottomWidth: 0.75,
          borderBottomColor: '#ccc',
        }}>
          {/* esquerda fixa: logo + brand */}
          <View style={{ width: 150, flexDirection: 'row', alignItems: 'center', gap: 6 }}>
            <Image src={logoUrl} style={{ width: 28, height: 28, objectFit: 'contain' }} />
            <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 10 }}>
              <Text style={{ color: '#111' }}>Vector </Text>
              <Text style={{ color: '#06B6D4' }}>Trac</Text>
              <Text style={{ color: '#10B981' }}>ker</Text>
            </Text>
          </View>
          {/* centro flex: título */}
          <View style={{ flex: 1, alignItems: 'center' }}>
            <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 13, letterSpacing: 0.5, textTransform: 'uppercase' }}>
              Formulário de Campo
            </Text>
          </View>
          {/* direita fixa: município */}
          <View style={{ width: 150, alignItems: 'flex-end' }}>
            <Text style={{ fontSize: 8, color: '#555', fontFamily: 'Helvetica-Bold' }}>
              {municipioNome || ''}
            </Text>
          </View>
        </View>

        {/* ── GRID 2 COLUNAS ── */}
        <View style={{ flexDirection: 'row', gap: 14 }}>

          {/* ─── COLUNA ESQUERDA ─── */}
          <View style={{ flex: 1 }}>

            <Section title="Dados da Atividade" />

            <View style={s.fieldGroup}>
              <Text style={s.fieldLabel}>Tipo de Atividade</Text>
              <View style={s.radioOptions}>
                <Radio label="Pesquisa"           checked={isPesquisa} />
                <Radio label="Borrifação"         checked={isBorrifacao} />
                <Radio label="Atendimento ao PIT" checked={isPit} />
              </View>
            </View>

            <View style={s.fieldGroup}>
              <Text style={s.fieldLabel}>Data da Atividade</Text>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View style={[s.dateBox, { width: 28 }]}><Text style={{ fontSize: 8.5, textAlign: 'center' }}>{day}</Text></View>
                <Text style={s.dateSep}>/</Text>
                <View style={[s.dateBox, { width: 28 }]}><Text style={{ fontSize: 8.5, textAlign: 'center' }}>{month}</Text></View>
                <Text style={s.dateSep}>/</Text>
                <View style={[s.dateBox, { width: 44 }]}><Text style={{ fontSize: 8.5, textAlign: 'center' }}>{year}</Text></View>
              </View>
            </View>

            <Field label="Número do PIT" value={data.numero_pit} />

            <Section title="Dados do Domicílio" />

            <View style={s.fieldRow}>
              <Field label="Código da Localidade" value={data.codigo_localidade} style={{ flex: 1 }} />
              <Field label="Categoria" value={data.categoria_localidade} style={{ flex: 0.7 }} />
            </View>

            <Field label="Localidade" value={data.nome_localidade} />
            <Field label="Endereço" value={enderecoFormatado} />

            <View style={s.fieldRow}>
              <Field label="Complemento" value={data.complemento} style={{ flex: 1 }} />
            </View>

            <RadioField
              label="Pendência da Pesquisa"
              options={[
                { v: 'semPendencias', l: 'Sem pendências'    },
                { v: 'fechado',       l: 'Domicílio fechado' },
                { v: 'recusa',        l: 'Recusa'            },
              ]}
              value={pendPesq}
            />

            <RadioField
              label="Pendência da Borrifação"
              options={[
                { v: 'semPendencias', l: 'Sem pendências'    },
                { v: 'fechado',       l: 'Domicílio fechado' },
                { v: 'recusa',        l: 'Recusa'            },
              ]}
              value={pendBorr}
            />

            <Field label="Nome do Morador" value={data.nome_morador} />

            <Field
              label="Quantidade de Moradores"
              value={String(data.quantidade_moradores ?? 0)}
              numeric
            />

            <View style={s.fieldGroup}>
              <Text style={s.fieldLabel}>Número do Anexo</Text>
              <View style={s.chipRow}>
                {[0,1,2,3,4,5].map(v => <Chip key={v} value={v} selected={numAnexo === v} />)}
              </View>
            </View>

            <RadioField
              label="Situação do Imóvel"
              options={[
                { v: 'reconhecida', l: 'Reconhecida (já pesquisada)' },
                { v: 'nova',        l: 'Nova (primeira pesquisa)'    },
                { v: 'demolida',    l: 'Demolida'                    },
              ]}
              value={situacao}
            />

            <View style={s.fieldGroup}>
              <Text style={s.fieldLabel}>Tipo de Parede</Text>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: 3 }}>
                {['Alvenaria com reboco','Alvenaria sem reboco','Barro com reboco','Barro sem reboco','Madeira','Taipa','Palha','Outros'].map(lbl => (
                  <View key={lbl} style={{ width: '50%', marginBottom: 3 }}>
                    <Radio label={lbl} checked={paredeNorm === lbl} />
                  </View>
                ))}
              </View>
            </View>

          </View>

          {/* ─── COLUNA DIREITA ─── */}
          <View style={{ flex: 1 }}>

            <View style={[s.fieldGroup, { marginTop: 14 }]}>
              <Text style={s.fieldLabel}>Tipo de Teto</Text>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: 3 }}>
                {['Telha','Palha','Madeira','Metálico','Outros'].map(lbl => (
                  <View key={lbl} style={{ width: '33%', marginBottom: 5 }}>
                    <Radio label={lbl} checked={tetoNorm === lbl} />
                  </View>
                ))}
              </View>
            </View>

            <RadioField
              label="Melhoria Habitacional"
              options={[{ v: true, l: 'Sim' }, { v: false, l: 'Não' }]}
              value={melhoria}
            />

            <Section title="Captura Triatomíneo — Intradomicílio" />

            <RadioField
              label="Captura"
              options={[{ v: 'Triatomíneo', l: 'Triatomíneo' }, { v: 'Nenhum', l: 'Nenhum' }]}
              value={captIntra}
            />
            <RadioField
              label="Vestígios"
              options={[{ v: 'Ovos', l: 'Ovos' }, { v: 'Nenhum', l: 'Nenhum' }]}
              value={vestIntra.includes('Ovos') ? 'Ovos' : 'Nenhum'}
            />
            <Field label="Número de Barbeiros" value={String(barbIntra)} numeric />

            <Section title="Captura Triatomíneo — Peridomicílio" />

            <RadioField
              label="Captura"
              options={[{ v: 'Triatomíneo', l: 'Triatomíneo' }, { v: 'Nenhum', l: 'Nenhum' }]}
              value={captPeri}
            />
            <RadioField
              label="Vestígios"
              options={[{ v: 'Ovos', l: 'Ovos' }, { v: 'Nenhum', l: 'Nenhum' }]}
              value={vestPeri.includes('Ovos') ? 'Ovos' : 'Nenhum'}
            />
            <Field label="Número de Barbeiros" value={String(barbPeri)} numeric />

            <Section title="Borrifação" />

            <Field label="Inseticida" value={data.inseticida} />

            <View style={s.fieldGroup}>
              <Text style={s.fieldLabel}>Número de Cargas</Text>
              <View style={s.chipRow}>
                {[0,1,2,3,4,5].map(v => <Chip key={v} value={v} selected={numCargas === v} />)}
              </View>
            </View>

            <Section title="Identificação" />

            <Field label="Código de Etiqueta" value={data.codigo_etiqueta} />
            <Field label="Agente de Endemias" value={agenteNome} />

          </View>
        </View>

      </Page>

      {/* PÁG 2 — REGISTROS E ANEXOS */}
      {temPag2 && (
        <Page size="A4" style={s.fotosPage}>

          {/* Mini cabeçalho */}
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, paddingBottom: 7, borderBottomWidth: 0.75, borderBottomColor: '#ccc' }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
              <Image src={logoUrl} style={{ width: 28, height: 28, objectFit: 'contain' }} />
              <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 10 }}>
                <Text style={{ color: '#111' }}>Vector </Text>
                <Text style={{ color: '#06B6D4' }}>Trac</Text>
                <Text style={{ color: '#10B981' }}>ker</Text>
              </Text>
            </View>
            <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 9 }}>Registros e Anexos</Text>
            <Text style={{ fontSize: 7.5, color: '#888' }}>
              {data.codigo_etiqueta ? `Etiqueta: ${data.codigo_etiqueta}` : ''}{data.endereco ? `  ·  ${data.endereco}${data.numero ? ', ' + data.numero : ''}` : ''}
            </Text>
          </View>

          {/* ── CONTEXTO DA DENÚNCIA ── */}
          {denunciaData && (
            <View style={{ marginBottom: 10 }}>
              <View style={s.sectionRow}>
                <Text style={s.sectionLabel}>Contexto da Denúncia</Text>
                <View style={s.sectionDash} />
              </View>

              {/* Foto da denúncia — altura controlada para caber na página */}
              {(denunciaData.fotoPrincipalUrl || fotoDenunciaUrl) && (
                <Image
                  src={fotoDenunciaUrl || denunciaData.fotoPrincipalUrl}
                  style={{ width: '100%', height: 160, objectFit: 'contain', marginBottom: 6 }}
                />
              )}

              {/* Dados em linha */}
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginBottom: 4 }}>
                {denunciaData.createdAt && (
                  <Text style={{ fontSize: 8 }}>
                    <Text style={{ fontFamily: 'Helvetica-Bold' }}>Data: </Text>
                    {new Date(denunciaData.createdAt).toLocaleString('pt-BR', { timeZone: 'UTC' })}
                  </Text>
                )}
                {(denunciaData.rua || denunciaData.numero) && (
                  <Text style={{ fontSize: 8 }}>
                    <Text style={{ fontFamily: 'Helvetica-Bold' }}>  ·  Endereço: </Text>
                    {[denunciaData.rua, denunciaData.numero].filter(Boolean).join(', ')}
                  </Text>
                )}
                {denunciaData.bairro && (
                  <Text style={{ fontSize: 8 }}>
                    <Text style={{ fontFamily: 'Helvetica-Bold' }}>  ·  Bairro: </Text>{denunciaData.bairro}
                  </Text>
                )}
              </View>
              {denunciaData.descricao && (
                <Text style={{ fontSize: 8, marginBottom: 4 }}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Descrição: </Text>{denunciaData.descricao}
                </Text>
              )}
              {denunciaData.id && (
                <Text style={{ fontSize: 6.5, color: '#aaa' }}>ID: {denunciaData.id}</Text>
              )}

              {/* Feedback do agente */}
              {feedbackAgente && (
                <View style={{ borderLeftWidth: 3, borderLeftColor: '#06B6D4', paddingLeft: 8, marginTop: 6 }}>
                  <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: 7.5, color: '#0369a1', marginBottom: 2 }}>
                    Feedback enviado ao cidadão:
                  </Text>
                  <Text style={{ fontSize: 8, fontFamily: 'Helvetica-Oblique', color: '#334155' }}>
                    "{feedbackAgente}"
                  </Text>
                </View>
              )}
            </View>
          )}

          {/* ── REGISTROS DO ATENDIMENTO ── */}
          {validFotos.length > 0 && (
            <View style={{ marginBottom: 10 }}>
              <View style={s.sectionRow}>
                <Text style={s.sectionLabel}>Registros do Atendimento</Text>
                <View style={s.sectionDash} />
              </View>
              <View style={s.fotosGrid}>
                {validFotos.map((url, i) => (
                  <View key={i} style={{ width: '48%', marginBottom: 6 }}>
                    <Image src={url} style={{ width: '100%', height: 140, objectFit: 'contain' }} />
                    <Text style={s.fotoCaption}>Foto {i + 1}</Text>
                  </View>
                ))}
              </View>
            </View>
          )}

          {/* ── ANEXO DA FICHA FÍSICA ── */}
          {validFicha.length > 0 && (
            <View>
              <View style={s.sectionRow}>
                <Text style={s.sectionLabel}>Anexo da Ficha Física</Text>
                <View style={s.sectionDash} />
              </View>
              <View style={s.fotosGrid}>
                {validFicha.map((url, i) => (
                  <View key={i} style={{ width: '48%', marginBottom: 6 }}>
                    <Image src={url} style={{ width: '100%', height: 160, objectFit: 'contain' }} />
                    <Text style={s.fotoCaption}>Ficha {i + 1}</Text>
                  </View>
                ))}
              </View>
            </View>
          )}

        </Page>
      )}

    </Document>
  );
};

/* ── UTILITÁRIO: converte URL remota → base64 (resolve CORS do Supabase) ── */
export const urlParaBase64 = (url) => {
  if (!url || typeof url !== 'string' || url.startsWith('data:')) return Promise.resolve(url);
  return new Promise((resolve) => {
    // Timeout agressivo (5s) para não travar o ZIP se uma imagem falhar
    const timeout = setTimeout(() => {
        console.warn('Timeout na conversão de imagem:', url);
        resolve(null);
    }, 5000);

    const el = document.createElement('img');
    el.crossOrigin = 'anonymous';
    el.onload = () => {
      clearTimeout(timeout);
      try {
        const canvas = document.createElement('canvas');
        canvas.width  = el.naturalWidth;
        canvas.height = el.naturalHeight;
        canvas.getContext('2d').drawImage(el, 0, 0);
        resolve(canvas.toDataURL('image/jpeg', 0.8));
      } catch (err) {
        console.error('Erro no canvas:', err);
        resolve(null);
      }
    };
    el.onerror = () => {
      clearTimeout(timeout);
      // Segunda tentativa via fetch se o element falhar
      fetch(url, { mode: 'cors' })
        .then(r => r.blob())
        .then(blob => new Promise((res, rej) => {
          const reader = new FileReader();
          reader.onloadend = () => res(reader.result);
          reader.onerror = rej;
          reader.readAsDataURL(blob);
        }))
        .then(resolve)
        .catch(() => resolve(null));
    };
    el.src = url;
  });
};

/* ── BOTÃO ── */
const sanitize = (str) =>
  String(str || '').trim()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/\s+/g, '_')
    .slice(0, 25);

export const BotaoDownloadFormularioPDF = ({
  data, agenteNome, municipioNome,
  fotosUrls = [], fotoDenunciaUrl = null,
  denunciaData = null, feedbackAgente = '', fichaFotosUrls = [],
  isReady = false,
}) => {
  const [imgFotos,    setImgFotos]    = useState([]);
  const [imgFicha,    setImgFicha]    = useState([]);
  const [imgDenuncia, setImgDenuncia] = useState(null);
  const [imgsReady,   setImgsReady]   = useState(false);

  useEffect(() => {
    if (!isReady) return;
    setImgsReady(false);
    const convert = async () => {
      const [f, fc, d] = await Promise.all([
        Promise.all((fotosUrls || []).map(u => urlParaBase64(u))),
        Promise.all((fichaFotosUrls || []).map(u => urlParaBase64(u))),
        fotoDenunciaUrl ? urlParaBase64(fotoDenunciaUrl) : Promise.resolve(null),
      ]);
      setImgFotos(f.filter(Boolean));
      setImgFicha(fc.filter(Boolean));
      setImgDenuncia(d);
      setImgsReady(true);
    };
    convert();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, (fotosUrls || []).join(','), (fichaFotosUrls || []).join(','), fotoDenunciaUrl]);

  const btnBase = {
    display: 'inline-flex', alignItems: 'center', gap: '7px',
    padding: '8px 18px', color: '#fff', border: 'none',
    borderRadius: '6px', fontWeight: '600', fontSize: '13px',
    fontFamily: "'Inter', sans-serif",
  };

  if (!isReady || !imgsReady) {
    return (
      <button disabled style={{ ...btnBase, background: '#9ca3af', cursor: 'not-allowed' }}>
        <DownloadIcon />
        {!isReady ? 'Baixar PDF' : 'Carregando imagens...'}
      </button>
    );
  }

  const parts = [
    sanitize(data.codigo_etiqueta),
    sanitize(data.endereco),
    sanitize(data.numero),
    sanitize(data.nome_localidade),
  ].filter(Boolean);
  const nomeArquivo = `FC_${parts.join('_')}.pdf`.replace(/_+/g, '_');

  return (
    <PDFDownloadLink
      document={
        <FormularioCampoPDFDocument
          data={data}
          agenteNome={agenteNome}
          municipioNome={municipioNome}
          fotosUrls={imgFotos}
          fotoDenunciaUrl={imgDenuncia}
          denunciaData={denunciaData}
          feedbackAgente={feedbackAgente}
          fichaFotosUrls={imgFicha}
        />
      }
      fileName={nomeArquivo}
      style={{ textDecoration: 'none' }}
    >
      {({ loading }) => (
        <button style={{ ...btnBase, background: loading ? '#6b7280' : '#111827', cursor: loading ? 'wait' : 'pointer' }}>
          <DownloadIcon />
          {loading ? 'Gerando PDF...' : 'Baixar Formulário PDF'}
        </button>
      )}
    </PDFDownloadLink>
  );
};

const DownloadIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
